import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "input-group-text"
};
const _hoisted_2 = ["value", "placeholder", "readonly", "aria-expanded"];
const _hoisted_3 = {
    key: 0,
    class: "g-search-box__label-display flex-shrink-0 text-muted",
    style: { "width": "unset" }
};
const _hoisted_4 = {
    key: 1,
    class: "input-group-text"
};
const _hoisted_5 = ["aria-label"];
const _hoisted_6 = ["title"];
const _hoisted_7 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_search_box__table = _resolveComponent("g-search-box__table");
    const _component_g_search_box__tree = _resolveComponent("g-search-box__tree");
    const _component_g_search_box__custom = _resolveComponent("g-search-box__custom");
    const _directive_resize2 = _resolveDirective("resize2");
    return (_openBlock(), _createElementBlock("div", {
        ref: "root",
        class: _normalizeClass(["g-search-box", { 'g-search-box--readonly': _ctx.readonly }])
    }, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
            ref: "input_group",
            class: "input-group",
            onClick: _cache[6] || (_cache[6] =
                //@ts-ignore
                (...args) => (_ctx.handleInputGroupClick && _ctx.handleInputGroupClick(...args)))
        }, [
            (_ctx.iconField && _ctx.selectedItem?.[_ctx.iconField])
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _createElementVNode("i", {
                        class: _normalizeClass(["bi g-search-box__item-icon", String(_ctx.selectedItem[_ctx.iconField])])
                    }, null, 2)
                ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", {
                class: _normalizeClass(["form-control g-search-box__control d-flex flex-grow-1", { 'g-search-box__control--open': _ctx.isOpen }]),
                onClick: _cache[3] || (_cache[3] =
                    //@ts-ignore
                    (...args) => (_ctx.handleInputGroupClick && _ctx.handleInputGroupClick(...args)))
            }, [
                _createElementVNode("input", {
                    ref: "inputEl",
                    type: "text",
                    class: "g-search-box__key-input flex-grow-1",
                    value: _ctx.displayKey,
                    placeholder: !_ctx.isOpen && _ctx.selectedItem ? '' : _ctx.placeholder,
                    readonly: _ctx.readonly,
                    "aria-expanded": _ctx.isOpen,
                    "aria-autocomplete": "list",
                    autocomplete: "off",
                    onInput: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.handleSearchInput && _ctx.handleSearchInput(...args))),
                    onFocus: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.handleFocus && _ctx.handleFocus(...args))),
                    onKeydown: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args)))
                }, null, 40, _hoisted_2),
                (!_ctx.isOpen && _ctx.selectedItem)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.displayLabel), 1))
                    : _createCommentVNode("", true)
            ], 2),
            (_ctx.isLoading || _ctx.isLoadingById)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createElementVNode("span", {
                        class: "spinner-border spinner-border-sm",
                        role: "status",
                        "aria-label": _ctx.$t('shared.Text.Loading')
                    }, null, 8, _hoisted_5)
                ]))
                : _createCommentVNode("", true),
            (_ctx.selectedItem && !_ctx.readonly && _ctx.showClearButton)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "btn btn-outline-secondary",
                    title: _ctx.$t('client.Forms.ClearSelection'),
                    tabindex: "-1",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.clearSelection && _ctx.clearSelection(...args)), ["stop"]))
                }, [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
                    ]))], 8, _hoisted_6))
                : _createCommentVNode("", true),
            (!_ctx.readonly)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    type: "button",
                    class: "btn btn-outline-secondary",
                    tabindex: "-1",
                    title: _ctx.isOpen ? _ctx.$t('shared.Text.Close') : _ctx.$t('shared.Text.Open'),
                    onClick: _cache[5] || (_cache[5] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["stop"]))
                }, [
                    _createElementVNode("i", {
                        class: _normalizeClass(["bi", _ctx.isOpen ? 'bi-chevron-up' : 'bi-chevron-down'])
                    }, null, 2)
                ], 8, _hoisted_7))
                : _createCommentVNode("", true)
        ])), [
            [_directive_resize2, { handler: _ctx.onMove, throttle: 16 }]
        ]),
        (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref: "dropdownEl",
                class: "g-search-box__dropdown",
                style: _normalizeStyle(_ctx.dropDownStyle),
                onScrollPassive: _cache[7] || (_cache[7] =
                    //@ts-ignore
                    (...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
            }, [
                (_ctx.dropdownMode === 'table')
                    ? (_openBlock(), _createBlock(_component_g_search_box__table, {
                        key: 0,
                        items: _ctx.displayItems,
                        columns: _ctx.columns,
                        "icon-field": _ctx.iconField,
                        "selected-item": _ctx.selectedItem,
                        "id-field": _ctx.idField,
                        "highlighted-index": _ctx.highlightedIndex,
                        "is-loading": _ctx.isLoading,
                        "is-loading-more": _ctx.isLoadingMore,
                        onSelect: _ctx.selectItem
                    }, null, 8, ["items", "columns", "icon-field", "selected-item", "id-field", "highlighted-index", "is-loading", "is-loading-more", "onSelect"]))
                    : (_ctx.dropdownMode === 'tree')
                        ? (_openBlock(), _createBlock(_component_g_search_box__tree, {
                            key: 1,
                            nodes: _ctx.visibleTreeNodes,
                            columns: _ctx.columns,
                            "icon-field": _ctx.iconField,
                            "selected-item": _ctx.selectedItem,
                            "id-field": _ctx.idField,
                            "select-leaf-only": _ctx.selectLeafOnly,
                            "expanded-ids": _ctx.expandedIds,
                            "highlighted-index": _ctx.highlightedIndex,
                            "is-loading": _ctx.isLoading,
                            "is-loading-more": _ctx.isLoadingMore,
                            onSelect: _ctx.selectItem,
                            onToggleNode: _ctx.toggleTreeNode
                        }, null, 8, ["nodes", "columns", "icon-field", "selected-item", "id-field", "select-leaf-only", "expanded-ids", "highlighted-index", "is-loading", "is-loading-more", "onSelect", "onToggleNode"]))
                        : (_ctx.dropdownMode === 'custom')
                            ? (_openBlock(), _createBlock(_component_g_search_box__custom, {
                                key: 2,
                                items: _ctx.displayItems,
                                "selected-item": _ctx.selectedItem,
                                "id-field": _ctx.idField,
                                "highlighted-index": _ctx.highlightedIndex,
                                "is-loading": _ctx.isLoading,
                                "is-loading-more": _ctx.isLoadingMore,
                                onSelect: _ctx.selectItem
                            }, {
                                item: _withCtx((slotProps) => [
                                    _renderSlot(_ctx.$slots, "item", _normalizeProps(_guardReactiveProps(slotProps)))
                                ]),
                                _: 3
                            }, 8, ["items", "selected-item", "id-field", "highlighted-index", "is-loading", "is-loading-more", "onSelect"]))
                            : _createCommentVNode("", true)
            ], 36))
            : _createCommentVNode("", true)
    ], 2));
}
